import { styled } from "@mui/material/styles";
import { Box, IconButton, MenuItem, Stack, Typography } from "@mui/material";
import { colors } from "../../theme/theme";
import { MenuOutlined } from "@mui/icons-material";

export const MenuIconButton = styled(IconButton)(({ theme }) => ({
  display: "none",
  color: colors.primary,
  alignItems: "center",
  alignSelf: "center",
  [theme.breakpoints.down("lg")]: {
    display: "flex",
  },
}));

export const LogoImg = styled(MenuOutlined)(({ theme }) => ({
  width: 35,
  height: 35,
  [theme.breakpoints.down("md")]: {
    width: 30,
    height: 30,
  },
}));

export const HeaderPlaceholder = styled(Box, {
  shouldForwardProp: (prop) => prop !== "height",
})(({ height }) => ({
  width: "100%",
  flexShrink: 0,
  ...(height != null && height > 0 && { minHeight: height }),
}));

export const RootWrapper = styled(Box, {
  shouldForwardProp: (prop) => !["isVisible", "isAtTop"].includes(prop),
})(({ theme, isVisible, isAtTop }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1100,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(4),
  transform: isVisible ? "translateY(0)" : "translateY(-100%)",
  transition: "transform 0.3s ease",
  ...(!isAtTop &&
    isVisible && {
      backgroundColor: colors.headerBg,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    }),
}));

export const LogoImgSmall = styled("img")(({ theme }) => ({
  cursor: "pointer",
  height: "50px",
  width: "50px",
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "block",
  },
}));

export const LogoImgFull = styled("img")(({ theme }) => ({
  height: "85px",
  width: "250px",
  cursor: "pointer",
  [theme.breakpoints.down("md")]: {
    height: "50px",
    width: "150px",
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const RightSectionStack = styled(Stack)(({ theme }) => ({
  width: "50%",
  justifyContent: "flex-end",
  flexDirection: "row",
  gap: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(1),
  },
}));

export const AvatarBox = styled(Box)(({ theme }) => ({
  height: "50px",
  width: "50px",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: colors.secondary,
  color: colors.white,
  fontFamily: "'Gotham', sans-serif",
  fontWeight: 700,
  fontSize: "22px",
  textTransform: "uppercase",
  minWidth: 50,
  minHeight: 50,
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
  },
}));

export const UserInfoStack = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const UserNameText = styled(Typography)(({ theme }) => ({
  color: colors.primary,
  fontFamily: "'Gotham', sans-serif",
  fontSize: "18px",
  fontWeight: 500,
  letterSpacing: "0.2px",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

export const UserRoleText = styled(Typography)(({ theme }) => ({
  color: colors.textLight,
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  textTransform: "capitalize",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));

export const MoreMenuIconButton = styled(IconButton)({
  height: "50px",
  width: "50px",
  color: colors.primary,
  alignSelf: "center",
});

export const StyledMenuItem = styled(MenuItem)({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 500,
});

export const SettingsIconButton = styled(IconButton)({
  width: 50,
  height: 50,
  alignItems: "center",
  justifyContent: "center",
  color: colors.primary,
});
